<div class="kt-portlet">
    <div class="kt-portlet__body">
        <div class="kt-infobox">
            <div class="kt-infobox__header">
                <h2 class="kt-infobox__title">{{announcement.title}}</h2>
            </div>
            <div class="kt-infobox__body">
                <div class="kt-infobox__section">
                    <div class="kt-infobox__content" [innerHtml]="announcement.description">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>